import React from 'react';

const SearchPopup = () => {
  return (
    <div className="search-popup">
      <div className="color-layer close-search"></div>
      <button className="close-search"><span className="fa fa-times"></span></button>
      <form method="post" action="#">
        <div className="form-group">
          <input type="search" name="search-field" placeholder="Search Here" required />
          <button type="submit"><i className="fa fa-search"></i></button>
        </div>
      </form>
    </div>
  );
};

export default SearchPopup;
